<div
  #container
  [class]="`filter-button filter-button--${alignment()}`"
  [id]="id"
>
  <procure-button-group>
    <button
      class="filter-button__toggle"
      procure-button
      filter
      wide
      suffix="arrow_drop_down"
      variant="flat"
      [matTooltip]="tooltip() ? tooltipValue() : ''"
      [color]="remainder() ? activeColor() : 'grey'"
      (click)="toggleOverlay()"
    >
      <span class="filter-button__label">
        @if (hasValue()) {
          <span>
            <b>{{ `${label()}:` }}</b>
            {{ filterOrganisations().length }} selected
          </span>
        } @else {
          {{ label() }}
        }
      </span>
    </button>
    @if (hasValue()) {
      <button
        class="filter-button__clear"
        procure-button
        filter
        [color]="activeColor()"
        [variant]="remainder() ? 'flat' : 'stroked'"
        (click)="reset()"
      >
        <mat-icon>clear</mat-icon>
      </button>
    }
  </procure-button-group>
  @if (isOpened()) {
    <div
      #overlay
      class="filter-button__overlay mat-elevation-z8 overlay"
    >
      <div formRow>
        <button
          class="overlay__button"
          procure-button
          variant="stroked"
          (click)="selectAll()"
        >
          Select All
        </button>
        <button
          class="overlay__button"
          procure-button
          variant="stroked"
          (click)="reset()"
        >
          Reset
        </button>
      </div>
      <ng-content />
      <div formRow>
        <div class="overlay__content">
          <procure-input-organisation
            [external]="external()"
            [label]="label()"
            [control]="control()"
            [hasPermissions]="hasPermissions()"
            [onlyLocalDivision]="onlyLocalDivision()"
            [showMode]="false"
            [selectAll]="all()"
            [organisations]="organisations()"
            (afterAllSelected)="afterAllSelected()"
          />
        </div>
      </div>
      <div formRow>
        <button
          class="overlay__button"
          procure-button
          variant="flat"
          (click)="toggleOverlay()"
        >
          Close
        </button>
      </div>
    </div>
  }
</div>
